import { Ban } from 'lucide-react';

interface PermissionDeniedProps {
  /** Optional override; defaults to the standard role-gate message. */
  message?: string;
}

/** Unified "you can't access this" state — centered (h + v) with a ban icon.
 *  Use for 403 / role-gated screens so the message looks consistent everywhere. */
export function PermissionDenied({ message }: PermissionDeniedProps) {
  return (
    <div className="flex min-h-[50vh] flex-col items-center justify-center gap-3 text-center">
      <Ban className="text-muted-foreground size-10" aria-hidden />
      <p className="text-muted-foreground max-w-sm text-sm">
        {message ?? 'You do not have the required role for this action.'}
      </p>
    </div>
  );
}
